// guards/module.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthContextService } from 'svnxii-ng-shared/services/auth-context';

export function moduleGuard(moduleKey: string): CanActivateFn {
  return async () => {
    const authContext = inject(AuthContextService);
    const router = inject(Router);
    await authContext.bootstrap();
    if (authContext.accessibleModuleKeys().has(moduleKey)) {
      return true;
    }
    return router.parseUrl('/app');
  };
}
